import {
    DESKTOP_FORM_FACTOR,
    MOBILE_FORM_FACTOR,
    TABLET_FORM_FACTOR
} from 'js/app/hooks/device/hooks/useMediaQuery/constants';
import { useInMobile, useInTablet } from 'js/app/hooks/device/hooks/useMediaQuery/useInDevice';

export const useCurrentFormFactor = () => {
    const isMobile = useInMobile();
    const isTablet = useInTablet();

    if (isMobile) {
        return MOBILE_FORM_FACTOR;
    }

    if (isTablet) {
        return TABLET_FORM_FACTOR;
    }

    return DESKTOP_FORM_FACTOR;
};
